import React from 'react';
import { Label, Spinner} from 'reactstrap';
import PropTypes from "prop-types";
import ImagePickerInputV2 from "./ImagePickerInputV2";
export const ImagePickerWorker = ( props ) => {
    const fbMediaConfig = props.config;
    const title = fbMediaConfig.fbMediaLabel;
    const mediaList = props.mediaList;

    const getMedia = (type, lang) => {
        if (fbMediaConfig.useGallery) {
            return mediaList?.find(item => item.fbMediaConfig.useGallery);
        }

        const suffix = fbMediaConfig.use18n
            ? (!fbMediaConfig.use18nSameImage
                ? (type === "thumb" ? `${lang}_thumb` : lang)
                : (type === "thumb" ? "thumb" : ""))
            : (type === "thumb" ? "thumb" : "");

        return mediaList?.find(item => item.suffix === suffix || (!suffix && (item.suffix === "" || item.suffix == null)));
    };

    return <>
        { !fbMediaConfig && <Spinner animation="border"/> }
        {
            fbMediaConfig &&
            <div className='image-picker-card'>
                {title &&
                    <Label className="image-picker-label">
                        <p>{title}</p>
                    </Label>
                }
                <div className="image-picker-worker-container">
                    {
                        <>
                            <ImagePickerInputV2
                                parent={props.parent}
                                objectMedia={getMedia("image", (fbMediaConfig.use18n && !fbMediaConfig.use18nSameImage) ? "ES" : "")}
                                type={"image"}
                                fbMediaConfig={fbMediaConfig}
                                onAddImage={_ => { }}
                                service={props.service}
                                lang={(fbMediaConfig.use18n && !fbMediaConfig.use18nSameImage) ? "ES" : ""}
                                mediaList={mediaList}
                                baseMediaService={props.baseMediaService}
                                afterUpload={props.afterUpload}
                            />
                            {fbMediaConfig.useThumb && (<ImagePickerInputV2
                                parent={props.parent}
                                objectMedia={getMedia("thumb", (fbMediaConfig.use18n && !fbMediaConfig.use18nSameImage) ? "ES" : "")}
                                type={"thumb"}
                                fbMediaConfig={fbMediaConfig}
                                onAddImage={_ => { }}
                                service={props.service}
                                lang={(fbMediaConfig.use18n && !fbMediaConfig.use18nSameImage) ? "ES" : ""}
                                mediaList={mediaList}
                                baseMediaService={props.baseMediaService}
                                afterUpload={props.afterUpload}
                            />)}
                        </>
                    }
                    {
                        (fbMediaConfig.use18n && !fbMediaConfig.use18nSameImage) &&
                        <>
                            <ImagePickerInputV2
                                parent={props.parent}
                                objectMedia={getMedia("image", (fbMediaConfig.use18n && !fbMediaConfig.use18nSameImage) ? "EN" : "")}
                                type={"image"}
                                fbMediaConfig={fbMediaConfig}
                                onAddImage={_ => { }}
                                service={props.service}
                                lang={(fbMediaConfig.use18n && !fbMediaConfig.use18nSameImage) ? "EN" : ""}
                                mediaList={mediaList}
                                baseMediaService={props.baseMediaService}
                                afterUpload={props.afterUpload}
                            />
                            {fbMediaConfig.useThumb && (<ImagePickerInputV2
                                parent={props.parent}
                                objectMedia={getMedia("thumb", (fbMediaConfig.use18n && !fbMediaConfig.use18nSameImage) ? "EN" : "")}
                                type={"thumb"}
                                fbMediaConfig={fbMediaConfig}
                                onAddImage={_ => { }}
                                service={props.service}
                                lang={(fbMediaConfig.use18n && !fbMediaConfig.use18nSameImage) ? "EN" : ""}
                                mediaList={mediaList}
                                baseMediaService={props.baseMediaService}
                                afterUpload={props.afterUpload}
                            />)}
                        </>
                    }
                </div>
            </div>
        }
    </>;
}


export default ImagePickerWorker;

ImagePickerWorker.propTypes = {
    mediaList: PropTypes.array,
    config: PropTypes.object.isRequired,
    objectMedia: PropTypes.object,
    isActive: PropTypes.bool.isRequired,
    service: PropTypes.object.isRequired
}